import { ReactNode } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

export interface HeroMetricProps {
  label: ReactNode;
  value: ReactNode;
  caption?: ReactNode;
  sx?: SxProps<Theme>;
}

/** Headline metric: a label, a large value, and an optional caption (e.g. last updated). */
export default function HeroMetric({
  label,
  value,
  caption,
  sx,
}: HeroMetricProps) {
  return (
    <Stack
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '4px',
        ...sx,
      }}
    >
      <Typography
        variant="body1"
        sx={{ color: (theme) => theme.palette.semantic.text.title2 }}
      >
        {label}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          color: (theme) => theme.palette.semantic.stepper.active,
          fontWeight: 400,
        }}
      >
        {value}
      </Typography>
      {caption != null && (
        <Typography
          variant="caption"
          sx={{ color: (theme) => theme.palette.semantic.text.support }}
        >
          {caption}
        </Typography>
      )}
    </Stack>
  );
}
